<template>
    <div class="page-container">
        
    </div>
</template>

<script>
export default {
    name: '',
    components:{
      
    },
    data() {
        return {
            
        }
    },
    mounted(){
        scrollTo(0,0);
    },
    methods: {
        
    }
}
</script>

<style scoped>

</style>


